import { ProjectDurationMetric, ReportsGroupBy } from '@models/interfaces';

import themeColors from 'styles/theme/colors.module.scss';

export const PROJECT_DURATION_CHART_COLORS = {
  averageByGroup: themeColors.yellow,
  distribution: themeColors.hoverPrimary,
  trend: themeColors.turquoise,
};

export const PROJECT_DURATION_DEFAULT_METRIC =
  ProjectDurationMetric.ProvidenceDays;

export const PROJECT_DURATION_METRIC_LABELS: Record<
  ProjectDurationMetric,
  string
> = {
  [ProjectDurationMetric.ProvidenceDays]: 'Providence Days',
  [ProjectDurationMetric.TotalProjectDays]: 'Project Days',
  [ProjectDurationMetric.PausedDays]: 'Paused Days',
};

export const PROJECT_DURATION_METRIC_OPTIONS: Array<{
  label: string;
  value: ProjectDurationMetric;
}> = [
  ProjectDurationMetric.ProvidenceDays,
  ProjectDurationMetric.TotalProjectDays,
  ProjectDurationMetric.PausedDays,
].map((value: ProjectDurationMetric) => ({
  label: PROJECT_DURATION_METRIC_LABELS[value],
  value,
}));

export const PROJECT_DURATION_GROUP_TITLE_BY_GROUP_BY: Partial<
  Record<ReportsGroupBy, string>
> = {
  [ReportsGroupBy.ProgressStatus]: 'Progress Status',
  [ReportsGroupBy.ProjectStatus]: 'Project Status',
  [ReportsGroupBy.ProjectSubtype]: 'Project Subtype',
  [ReportsGroupBy.ProjectType]: 'Project Type',
  [ReportsGroupBy.ProvidenceAgent]: 'Providence Agent',
  [ReportsGroupBy.State]: 'State',
  [ReportsGroupBy.Submarket]: 'Submarket',
  [ReportsGroupBy.TowerOwner]: 'Tower Owner',
};
